import { API, Logger } from 'aws-amplify';
import { ERROR_CONSTS, AppAPIName } from '../../constants';
import { AppThunkAction } from '../reduxTypes';
import { OnBoardingTask } from '../user/types';
import { TasksActionTypes } from './types';
import { alertSnackbar } from '../ui/actions';

const logger = new Logger('TaskStoreActions');
const OnboardingTasksApi = '/onboarding/tasks';

/**
 * Set the tasks from initial data load
 */
export const setTasksAction = (tasks: OnBoardingTask[]) => ({
  type: TasksActionTypes.SET_TASKS_SUCCESS,
  payload: tasks,
});

/**
 * Get task action sends request to get tasks
 * @returns an action object which will be dispatched
 */
export const getTasks = (): AppThunkAction => async dispatch => {
  function request() {
    return { type: TasksActionTypes.GET_TASKS };
  }

  function failure(error: string) {
    return { type: TasksActionTypes.GET_TASKS_ERROR, error };
  }

  function success(payload: OnBoardingTask[]) {
    return { type: TasksActionTypes.GET_TASKS_SUCCESS, payload };
  }

  dispatch(request());

  try {
    const res = await API.get(AppAPIName, OnboardingTasksApi, {});
    dispatch(success(res));
  } catch (err) {
    dispatch(failure(err));
  }
};

/**
 * Mark done task action sends request to mark done the task
 * @param taskCode unique code of task
 * @returns a thunkAction to mark task as done
 */
export const markDoneTask = (
  taskCode: string,
): AppThunkAction => async dispatch => {
  try {
    const response: OnBoardingTask = await API.post(
      AppAPIName,
      `${OnboardingTasksApi}?taskCode=${taskCode}`,
      {
        body: {
          done: true,
        },
      },
    );
    dispatch({
      type: TasksActionTypes.MARK_DONE_TASK,
      payload: response,
    });
  } catch (err) {
    dispatch(
      alertSnackbar({
        errorMessage: `${ERROR_CONSTS.UnableToChangeTask} ${ERROR_CONSTS.PleaseTryAgain}`,
      }),
    );
    logger.debug(err);
  }
};

/**
 * Mark undone task action sends request to mark undone the task
 * @param taskCode unique code of task
 * @returns a thunkAction to mark task as done
 */
export const markUndoneTask = (
  taskCode: string,
): AppThunkAction => async dispatch => {
  try {
    const response: OnBoardingTask = await API.post(
      AppAPIName,
      `${OnboardingTasksApi}?taskCode=${taskCode}`,
      {
        body: {
          done: false,
        },
      },
    );
    dispatch({
      type: TasksActionTypes.MARK_UNDONE_TASK,
      payload: response,
    });
  } catch (err) {
    dispatch(
      alertSnackbar({
        errorMessage: `${ERROR_CONSTS.UnableToChangeTask} ${ERROR_CONSTS.PleaseTryAgain}`,
      }),
    );
    logger.debug(err);
  }
};

/**
 * Track copy link task action and mark done the task
 * @param taskCode unique code of task
 */
export const trackCopyLinkTask = (
  taskCode: string,
): AppThunkAction => async dispatch => {
  try {
    await API.patch(AppAPIName, `/onboarding/status`, {
      body: {
        taskCode,
      },
    });
    dispatch({
      type: TasksActionTypes.TRACK_COPY_LINK_TASK,
    });
  } catch (err) {
    dispatch(
      alertSnackbar({
        errorMessage: `${ERROR_CONSTS.UnableToChangeTask} ${ERROR_CONSTS.PleaseTryAgain}`,
      }),
    );
    logger.debug(err);
  }
};
